/* =============================================================================
   Eterno Grafiche — Configuratore Fotoceramiche v1.0
   ============================================================================= */

(function () {
  'use strict';

  const LS_KEY = 'eterno_cer_v1';

  // ==========================================================================

  class EternoCeramiche {

    constructor() {
      this.data = {
        codice:       null,
        titolo:       null,
        orientamento: 'verticale',
        supportaTesto: false,
        prezzo:       0,
        fotoArea:     null,
        imgUrl:       null,
        bordi:        'netti',
        hasFoto:      false,
        fotoDataUrl:  null,
        nome:         '',
        nascita:      '',
        morte:        '',
        testo:        '',
        quantita:     1,
        cNome:        '',
        cCognome:     '',
        cEmail:       '',
        cTel:         '',
        cNote:        '',
        privacy:      false,
      };
      this.stepIndex   = 0;
      this._toastTimer = null;
      this.init();
    }

    // ---- Step sequence (dinamica: dati-testo compare solo se supportaTesto) ---

    get steps() {
      const s = ['scegli-ceramica', 'foto-bordi'];
      if (this.data.supportaTesto) s.push('dati-testo');
      s.push('checkout');
      return s;
    }

    get currentStep() { return this.steps[this.stepIndex]; }

    // ---- Init ----------------------------------------------------------------

    init() {
      const form = document.getElementById('ConfCeramicheForm');
      if (!form) return;

      this.bindCeramicaCards();
      this.bindFotoUpload();
      this.bindBordiRadio();
      this.bindTestoInputs();
      this.bindQty();
      this.bindCheckoutInputs();
      this.bindNav();

      if (this.loadFromStorage()) this.restoreFormFields();

      this.updateUI();
      this.updateBreadcrumb();
      this.updatePreview();
      this.updatePriceHint();
    }

    // ---- Ceramica selection --------------------------------------------------

    bindCeramicaCards() {
      document.querySelectorAll('.ccer-card').forEach(card => {
        card.addEventListener('click', () => this.onCeramicaSelect(card));
      });
    }

    onCeramicaSelect(card) {
      document.querySelectorAll('.ccer-card').forEach(c => c.classList.remove('is-selected'));
      card.classList.add('is-selected');

      this.data.codice       = card.dataset.codice || null;
      this.data.titolo       = card.dataset.titolo || null;
      this.data.supportaTesto = (card.dataset.supportaTesto || '').toLowerCase() === 'si';
      this.data.orientamento = card.dataset.orientamento || 'verticale';
      this.data.prezzo       = parseFloat(card.dataset.prezzo) || 0;
      this.data.imgUrl       = card.dataset.imgUrl || null;

      try {
        this.data.fotoArea = card.dataset.fotoArea ? JSON.parse(card.dataset.fotoArea) : null;
      } catch (_) {
        this.data.fotoArea = null;
      }

      const frameImg = document.getElementById('ccer-frame-img');
      if (frameImg && this.data.imgUrl) {
        frameImg.src = this.data.imgUrl;
        frameImg.alt = this.data.titolo || '';
      }

      this.updatePreview();
      this.updateBreadcrumb();
      this.updatePriceHint();
      this.saveToStorage();
    }

    // ---- Foto upload ---------------------------------------------------------

    bindFotoUpload() {
      const input = document.getElementById('ccer-foto-upload');
      if (!input) return;

      input.addEventListener('change', () => {
        const file = input.files && input.files[0];
        if (!file || !file.type.startsWith('image/')) return;
        const reader = new FileReader();
        reader.onload = e => {
          this.data.fotoDataUrl = e.target.result;
          this.data.hasFoto     = true;
          this._applyFotoToPreview(e.target.result);

          const label = document.getElementById('ccer-upload-label');
          if (label) {
            label.classList.add('has-foto');
            const txt = document.getElementById('ccer-upload-label-text');
            if (txt) txt.textContent = 'Foto caricata — clicchi per cambiarla';
          }

          const note = document.getElementById('ccer-foto-note');
          if (note) note.style.display = '';

          const fotoBtn = document.getElementById('ccer-invia-foto');
          if (fotoBtn && this.currentStep === 'checkout') fotoBtn.classList.remove('conf-hidden');

          this.updateBreadcrumb();
          this.saveToStorage();
        };
        reader.readAsDataURL(file);
      });
    }

    _applyFotoToPreview(dataUrl) {
      const layer = document.getElementById('ccer-foto-layer');
      if (!layer) return;

      let img = document.getElementById('ccer-user-photo');
      if (!img) {
        img = document.createElement('img');
        img.id  = 'ccer-user-photo';
        img.alt = 'La foto caricata';
        layer.appendChild(img);
      }
      img.src = dataUrl;

      document.getElementById('ccer-preview-ph')?.classList.add('conf-hidden');
      document.getElementById('ccer-preview-composite')?.classList.remove('conf-hidden');

      this.updatePreview();
    }

    // ---- Bordi radio ---------------------------------------------------------

    bindBordiRadio() {
      document.querySelectorAll('input[name="bordi"]').forEach(r => {
        r.addEventListener('change', () => {
          this.data.bordi = r.value;
          this._applyBordiClass();
          this.updateBreadcrumb();
          this.saveToStorage();
        });
      });
    }

    _applyBordiClass() {
      const layer = document.getElementById('ccer-foto-layer');
      if (layer) layer.classList.toggle('sfumato', this.data.bordi === 'sfumati');
    }

    // ---- Testo inputs --------------------------------------------------------

    bindTestoInputs() {
      const charCount = document.getElementById('ct-testo-count');

      [
        ['ct-nome',    'nome'],
        ['ct-nascita', 'nascita'],
        ['ct-morte',   'morte'],
      ].forEach(([id, key]) => {
        const el = document.getElementById(id);
        if (el) el.addEventListener('input', () => {
          this.data[key] = el.value;
          this.updateBreadcrumb();
          this.saveToStorage();
        });
      });

      const testoEl = document.getElementById('ct-testo');
      if (testoEl) {
        testoEl.addEventListener('input', () => {
          this.data.testo = testoEl.value;
          if (charCount) charCount.textContent = testoEl.value.length;
          this.saveToStorage();
        });
      }
    }

    // ---- Quantità ------------------------------------------------------------

    bindQty() {
      const input = document.getElementById('ct-qty');
      if (!input) return;

      const clamp = () => {
        const v = Math.max(1, parseInt(input.value) || 1);
        input.value        = v;
        this.data.quantita = v;
        this.updatePriceHint();
        this.updateBreadcrumb();
        this.saveToStorage();
      };

      document.getElementById('ccer-qty-minus')?.addEventListener('click', () => {
        input.value = Math.max(1, parseInt(input.value || 1) - 1);
        clamp();
      });
      document.getElementById('ccer-qty-plus')?.addEventListener('click', () => {
        input.value = parseInt(input.value || 1) + 1;
        clamp();
      });
      input.addEventListener('change', clamp);
    }

    // ---- Checkout inputs -----------------------------------------------------

    bindCheckoutInputs() {
      [
        ['cc-nome',    'cNome'],
        ['cc-cognome', 'cCognome'],
        ['cc-email',   'cEmail'],
        ['cc-tel',     'cTel'],
        ['cc-note',    'cNote'],
      ].forEach(([id, key]) => {
        const el = document.getElementById(id);
        if (el) el.addEventListener('input', () => {
          this.data[key] = el.value;
          this.updateLiveRecap();
          this.saveToStorage();
        });
      });

      const privacyEl = document.getElementById('cc-privacy');
      if (privacyEl) privacyEl.addEventListener('change', () => {
        this.data.privacy = privacyEl.checked;
        this.saveToStorage();
      });
    }

    // ---- Navigation ----------------------------------------------------------

    bindNav() {
      document.getElementById('ccer-next')?.addEventListener('click', () => this.next());
      document.getElementById('ccer-prev')?.addEventListener('click', () => this.prev());
      document.getElementById('ccer-submit')?.addEventListener('click', () => this.addToCart());
      document.getElementById('ccer-invia-foto')?.addEventListener('click', () => this.sendFotoByEmail());
    }

    next() {
      if (!this.validate()) return;
      if (this.stepIndex < this.steps.length - 1) {
        this.stepIndex++;
        this.updateUI();
        this.saveToStorage();
        this._scrollToConf();
      }
    }

    prev() {
      if (this.stepIndex > 0) {
        this.stepIndex--;
        this.clearError();
        this.updateUI();
        this.saveToStorage();
        this._scrollToConf();
      }
    }

    _scrollToConf() {
      const el = document.getElementById('EternoCerConf');
      if (!el) return;
      const headerEl = document.querySelector('sticky-header') || document.querySelector('.shopify-section-group-header-group');
      const headerH  = headerEl ? headerEl.offsetHeight : 0;
      const top      = el.getBoundingClientRect().top + window.scrollY - headerH - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    // ---- Validation ----------------------------------------------------------

    validate() {
      const s   = this.currentStep;
      const err = msg => { this.showError(msg); return false; };

      if (s === 'scegli-ceramica') {
        if (!this.data.codice) return err('Selezioni una fotoceramica per proseguire.');
        this.clearError(); return true;
      }

      if (s === 'foto-bordi') {
        if (!this.data.hasFoto) return err('Carichi la foto prima di proseguire.');
        this.clearError(); return true;
      }

      if (s === 'dati-testo') {
        const nascita = parseInt(document.getElementById('ct-nascita')?.value);
        const morte   = parseInt(document.getElementById('ct-morte')?.value);
        if (nascita && morte && nascita >= morte) {
          return err("L'anno di nascita deve essere precedente all'anno di morte.");
        }
        this.data.nome    = document.getElementById('ct-nome')?.value.trim() || '';
        this.data.nascita = document.getElementById('ct-nascita')?.value.trim() || '';
        this.data.morte   = document.getElementById('ct-morte')?.value.trim() || '';
        this.data.testo   = document.getElementById('ct-testo')?.value.trim() || '';
        this.clearError(); return true;
      }

      if (s === 'checkout') {
        const qty = parseInt(document.getElementById('ct-qty')?.value);
        if (!qty || qty < 1) return err('La quantità minima è 1.');
        this.data.quantita = qty;

        const cNome    = document.getElementById('cc-nome')?.value.trim();
        const cCognome = document.getElementById('cc-cognome')?.value.trim();
        const cEmail   = document.getElementById('cc-email')?.value.trim();
        const cTel     = document.getElementById('cc-tel')?.value.trim();
        const privacy  = document.getElementById('cc-privacy')?.checked;

        if (!cNome)    return err('Inserisca il suo nome.');
        if (!cCognome) return err('Inserisca il suo cognome.');

        const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        if (!cEmail || !emailRe.test(cEmail)) return err('Inserisca un indirizzo email valido (es. nome@dominio.it).');

        if (!cTel) return err('Inserisca un numero di telefono.');
        const telClean = cTel.replace(/[\s\-().+]/g, '');
        if (!/^(39)?(3\d{8,9}|0\d{7,10})$/.test(telClean)) return err('Inserisca un numero di telefono valido (es. 333 1234567).');

        if (!privacy) return err('Per procedere è necessario accettare la Privacy Policy.');

        this.data.cNome    = cNome;
        this.data.cCognome = cCognome;
        this.data.cEmail   = cEmail;
        this.data.cTel     = cTel;
        this.data.cNote    = document.getElementById('cc-note')?.value.trim() || '';
        this.data.privacy  = privacy;
        this.clearError(); return true;
      }

      this.clearError();
      return true;
    }

    // ---- Preview live --------------------------------------------------------

    updatePreview() {
      const { codice, fotoArea, bordi } = this.data;

      const ph        = document.getElementById('ccer-preview-ph');
      const composite = document.getElementById('ccer-preview-composite');

      if (!codice) {
        ph?.classList.remove('conf-hidden');
        composite?.classList.add('conf-hidden');
        return;
      }

      ph?.classList.add('conf-hidden');
      composite?.classList.remove('conf-hidden');

      if (fotoArea) {
        const layer = document.getElementById('ccer-foto-layer');
        if (layer) {
          layer.style.top    = fotoArea.top_pct    + '%';
          layer.style.left   = fotoArea.left_pct   + '%';
          layer.style.width  = fotoArea.width_pct  + '%';
          layer.style.height = fotoArea.height_pct + '%';
        }
      }

      this._applyBordiClass();

      const hint = document.getElementById('ccer-preview-hint');
      if (hint) {
        hint.textContent = this.data.hasFoto
          ? ''
          : 'Carichi la foto per vedere l\'anteprima completa';
      }
    }

    // ---- Price hint ----------------------------------------------------------

    updatePriceHint() {
      const el = document.getElementById('ccer-price-hint');
      if (!el) return;
      const { prezzo, quantita } = this.data;
      if (!prezzo) { el.textContent = ''; return; }
      const tot = (prezzo * quantita).toFixed(2).replace('.', ',');
      const ppu = prezzo.toFixed(2).replace('.', ',');
      el.textContent = `Totale: €${tot} (${quantita} pz × €${ppu}/pz)`;
    }

    // ---- Breadcrumb ----------------------------------------------------------

    updateBreadcrumb() {
      const el = document.getElementById('ccer-breadcrumb');
      if (!el) return;
      const d = this.data;

      const items = [
        d.titolo,
        d.bordi === 'sfumati' && 'Bordi sfumati',
        d.hasFoto && 'Foto caricata',
        d.nome && d.supportaTesto && d.nome,
        d.quantita && d.quantita > 1 && (d.quantita + ' pz'),
      ].filter(Boolean);

      if (!items.length) { el.innerHTML = ''; return; }

      el.innerHTML = items.map((item, i) =>
        '<span class="conf-breadcrumb__item">' + this.esc(item) + '</span>' +
        (i < items.length - 1 ? '<span class="conf-breadcrumb__sep" aria-hidden="true">›</span>' : '')
      ).join('');
    }

    // ---- Live recap (checkout step) -----------------------------------------

    updateLiveRecap() {
      if (this.currentStep !== 'checkout') return;
      const inner = document.getElementById('ccer-recap-inner');
      if (!inner) return;
      inner.innerHTML = this.buildRecapHTML();
    }

    buildRecapHTML() {
      const d    = this.data;
      const tot  = d.prezzo ? '€' + (d.prezzo * d.quantita).toFixed(2).replace('.', ',') +
                   ' (' + d.quantita + ' pz × €' + d.prezzo.toFixed(2).replace('.', ',') + '/pz)' : '—';
      let html = '';

      html += this.recapSection('Ceramica', [
        ['Modello',    d.titolo],
        ['Bordi',      d.bordi === 'sfumati' ? 'Sfumati' : 'Netti'],
        ['Quantità',   d.quantita + ' pz'],
        ['Totale',     tot],
      ].filter(Boolean));

      if (d.supportaTesto) {
        const testoRows = [
          d.nome    && ['Nome e cognome', d.nome],
          d.nascita && ['Anno di nascita', d.nascita],
          d.morte   && ['Anno di morte',   d.morte],
          d.testo   && ['Testo',           d.testo],
        ].filter(Boolean);
        if (testoRows.length) html += this.recapSection('Personalizzazione', testoRows);
      }

      const contRows = [
        (d.cNome || d.cCognome) && ['Nome e Cognome', [d.cNome, d.cCognome].filter(Boolean).join(' ')],
        d.cEmail && ['Email',    d.cEmail],
        d.cTel   && ['Telefono', d.cTel],
        d.cNote  && ['Note',     d.cNote],
      ].filter(Boolean);
      if (contRows.length) html += this.recapSection('Richiedente', contRows);

      return html;
    }

    recapSection(title, rows) {
      let dl = '<div class="conf-recap__section">' +
               '<h3 class="conf-recap__heading">' + this.esc(title) + '</h3>' +
               '<dl class="conf-recap__list">';
      rows.forEach(([dt, dd]) => {
        if (!dd) return;
        dl += '<dt>' + this.esc(dt) + '</dt><dd>' + this.esc(String(dd)) + '</dd>';
      });
      return dl + '</dl></div>';
    }

    // ---- UI update -----------------------------------------------------------

    updateUI() {
      const steps   = this.steps;
      const current = this.currentStep;
      const total   = steps.length;
      const index   = this.stepIndex;

      document.querySelectorAll('.conf-step').forEach(el => {
        const active = el.dataset.step === current;
        el.classList.toggle('conf-step--active', active);
        el.style.display = active ? '' : 'none';
      });

      const pct  = Math.round(((index + 1) / total) * 100);
      const fill = document.getElementById('ccer-bar');
      if (fill) fill.style.width = pct + '%';
      this._setText('ccer-bar-curr', index + 1);
      this._setText('ccer-bar-tot',  total);

      const prevBtn   = document.getElementById('ccer-prev');
      const nextBtn   = document.getElementById('ccer-next');
      const submitBtn = document.getElementById('ccer-submit');
      const fotoBtn   = document.getElementById('ccer-invia-foto');
      const isLast    = index === total - 1;

      if (prevBtn)   prevBtn.disabled = index === 0;
      nextBtn?.classList.toggle('conf-hidden',   isLast);
      submitBtn?.classList.toggle('conf-hidden', !isLast);
      if (fotoBtn) fotoBtn.classList.toggle('conf-hidden', !(isLast && this.data.hasFoto));

      this.clearError();
      this.updateBreadcrumb();
      this.updatePreview();
      if (isLast) {
        this.updateLiveRecap();
        this.updatePriceHint();
      }
    }

    // ---- Aggiungi al carrello ------------------------------------------------

    async addToCart() {
      if (!this.validate()) return;

      const d         = this.data;
      const variantId = window.EternoCeramicheVariants && window.EternoCeramicheVariants[d.codice];
      if (!variantId) {
        this.showError('Configurazione non disponibile — ricarichi la pagina e riprovi.');
        return;
      }

      const btn = document.getElementById('ccer-submit');
      if (btn) { btn.disabled = true; btn.textContent = 'Aggiunta in corso…'; }
      this.clearError();

      const props = {
        'Ceramica': d.titolo,
        'Bordi':    d.bordi === 'sfumati' ? 'Sfumati' : 'Netti',
        'Foto':     d.hasFoto ? 'In arrivo via email' : 'Non inviata',
      };

      if (d.supportaTesto) {
        if (d.nome)    props['Nome e cognome']  = d.nome;
        if (d.nascita) props['Anno di nascita'] = d.nascita;
        if (d.morte)   props['Anno di morte']   = d.morte;
        if (d.testo)   props['Testo ceramica']  = d.testo;
      }

      if (d.cNote) props['Note'] = d.cNote;

      try {
        const res = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body:    JSON.stringify({ id: variantId, quantity: d.quantita, properties: props }),
        });
        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.description || "Errore durante l'aggiunta al carrello.");
        }
        try { sessionStorage.removeItem(LS_KEY); } catch (_) {}
        window.location.href = '/cart';
      } catch (e) {
        this.showError(e.message);
        if (btn) { btn.disabled = false; btn.textContent = 'Aggiunga al carrello'; }
      }
    }

    // ---- Invia foto via email ------------------------------------------------

    sendFotoByEmail() {
      const email   = document.getElementById('EternoCerConf')?.dataset.email || 'info@eternografiche.it';
      const dataUrl = this.data.fotoDataUrl;

      if (!dataUrl || !dataUrl.startsWith('data:')) {
        this.showError('La foto non è più in memoria: torni al passo precedente e la carichi di nuovo.');
        return;
      }

      const nome     = this.data.titolo || 'ceramica';
      const filename = 'foto-' + nome.toLowerCase().replace(/\s+/g, '-') + '.jpg';
      const a        = document.createElement('a');
      a.href         = dataUrl;
      a.download     = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      setTimeout(() => {
        const subject = encodeURIComponent('Foto fotoceramica — ' + nome);
        const body    = encodeURIComponent(
          'Gentile Eterno Grafiche,\n\nallego la foto per la fotoceramica "' + nome + '".\n\nCordiali saluti'
        );
        window.location.href = 'mailto:' + email + '?subject=' + subject + '&body=' + body;
      }, 400);
    }

    // ---- sessionStorage ------------------------------------------------------

    saveToStorage() {
      try {
        const payload = {
          data:      Object.assign({}, this.data, { fotoDataUrl: null }),
          stepIndex: this.stepIndex,
        };
        sessionStorage.setItem(LS_KEY, JSON.stringify(payload));
      } catch (_) {}
    }

    loadFromStorage() {
      try {
        const raw = sessionStorage.getItem(LS_KEY);
        if (!raw) return false;
        const saved = JSON.parse(raw);
        if (!saved || !saved.data) return false;
        Object.assign(this.data, saved.data);
        this.stepIndex = Math.min(saved.stepIndex || 0, 3);
        return true;
      } catch (_) { return false; }
    }

    restoreFormFields() {
      const d = this.data;

      const set = (id, val) => {
        if (val === null || val === undefined || val === '') return;
        const el = document.getElementById(id);
        if (el) el.value = val;
      };

      set('ct-nome',    d.nome);
      set('ct-nascita', d.nascita);
      set('ct-morte',   d.morte);
      set('ct-testo',   d.testo);
      set('ct-qty',     d.quantita);
      set('cc-nome',    d.cNome);
      set('cc-cognome', d.cCognome);
      set('cc-email',   d.cEmail);
      set('cc-tel',     d.cTel);
      set('cc-note',    d.cNote);

      if (d.testo) {
        const cnt = document.getElementById('ct-testo-count');
        if (cnt) cnt.textContent = d.testo.length;
      }

      const cb = (id, val) => { const el = document.getElementById(id); if (el) el.checked = !!val; };
      cb('cc-privacy',   d.privacy);

      if (d.bordi) {
        document.querySelectorAll('input[name="bordi"]').forEach(r => { r.checked = r.value === d.bordi; });
        this._applyBordiClass();
      }

      if (d.codice) {
        const card = document.querySelector(`.ccer-card[data-codice="${CSS.escape ? CSS.escape(d.codice) : d.codice}"]`);
        if (card) {
          card.classList.add('is-selected');
          const frameImg = document.getElementById('ccer-frame-img');
          if (frameImg && d.imgUrl) frameImg.src = d.imgUrl;
        }
      }

      if (d.hasFoto) {
        const label = document.getElementById('ccer-upload-label');
        if (label) {
          label.classList.add('has-foto');
          const txt = document.getElementById('ccer-upload-label-text');
          if (txt) txt.textContent = 'Foto caricata — clicchi per cambiarla';
        }
        const note = document.getElementById('ccer-foto-note');
        if (note) note.style.display = '';
      }
    }

    // ---- Error / Toast -------------------------------------------------------

    showError(msg) {
      const el = document.getElementById('ccer-error');
      if (el) { el.textContent = msg; el.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
    }

    clearError() {
      const el = document.getElementById('ccer-error');
      if (el) el.textContent = '';
    }

    showToast(msg, duration = 3500) {
      const el = document.getElementById('ccer-toast');
      if (!el) return;
      el.textContent = msg;
      el.classList.add('conf-toast--visible');
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(() => el.classList.remove('conf-toast--visible'), duration);
    }

    // ---- Helpers -------------------------------------------------------------

    _setText(id, text) {
      const el = document.getElementById(id);
      if (el) el.textContent = text;
    }

    esc(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }
  }

  // ==========================================================================
  document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('ConfCeramicheForm')) new EternoCeramiche();
  });

})();
